import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useConnectionTypeOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isConnectionTypeLoading,
    data: connectionTypeOptions,
    refetch: refetchOptions,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Connection Type options'),
    optionType: OptionsType.CONNECTION_TYPE,
    queryOptions,
  });

  return {
    connectionTypeOptions,
    isConnectionTypeLoading,
    refetchOptions,
  };
}
